module.exports = __webpack_public_path__ + "static/media/yash_gangwar.29a8d24a.jpg";